import { PaymentContainer } from "../containers/PaymentContainer";

export const PaymentPage = () => <PaymentContainer />;
